import { Button, Grid, Radio } from "@material-ui/core"
import React, { useEffect, useRef, useState } from "react"
import { FilterIcon } from "src/components/Icons"
import useStyles from "src/app/maintenance/assets/styles"
import { Typography } from "antd"

export const BatchFilter = (props) => {
    const classes = useStyles()
    const [batches, setBatches] = useState([])
    const href = useRef(null)

    const handleCloseFilter = () => {
        props.setFilterVisible(false);
        if (props.onCancel) {
            props.onCancel();
        }
    }

    useEffect(() =>{
        if(props.batches){
            setBatches([
                ...props.batches
            ])
        }
    },[props.batches])

    const handleClickOutside = (event) => {
        if (href.current && !href.current.contains(event.target) && event.target.closest('.filter-validity')) {
            props.setFilterVisible(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Grid item  ref={href} className="filter-validity" style={{ position: 'relative',zIndex:1 }}>
            <div className="filerButton" onClick={props.toggleFilter} style={{ display: 'flex', alignItems: 'center' }}>
                <FilterIcon />
                <span style={{ marginLeft: '4px' }}>Filter</span>
            </div>
            {props.filterVisible && (
                <div className={classes.filterOptions}>
                    <Grid item style={{borderBottom:'1px solid #EDEDED',marginBottom:'10px'}}>
                        <Typography className={classes.filterTypo}>Filter</Typography>
                    </Grid>
                    <Grid item style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {props.filterType === 'batchNumber' ? <Typography className={classes.batchTypo}>Batch</Typography> : ""}
                        {batches.map((batch, index) => (
                            <div key={index} className={classes.prefixSelect} onClick={() =>props.handlePrefixSelect(batch)}>
                                <Radio
                                    className={classes.filterRadio}
                                    value={`prefix-${index}`}
                                    checked={props.selectedBatch === batch}
                                    onChange={() => props.handleBatchSelect(batch)}
                                    color="default"
                                />
                                <label htmlFor={`prefix-${index}`} style={{ marginLeft: '8px' }}>
                                    {batch}
                                </label>
                            </div>
                        ))}
                    </Grid>
                    <Grid container justifyContent="flex-end" style={{paddingRight:'10px'}}>
                        <Button variant= 'outlined' style={{marginRight:'10px'}} onClick={handleCloseFilter}>Cancel</Button>
                        <Button variant='contained' style={{backgroundColor:'#2A7BEC',color:'white'}} onClick={props.filterBatch}>Apply Filter</Button>
                    </Grid>
                </div>
            )}
        </Grid>
    )
}